<div class="h-xl-100">
  <div class="card-body">
    <div class="d-flex flex-stack">
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-1">
          ข้อมูลการเข้าเรียนและทำข้อสอบ
        </h1>
        <span class="text-muted fs-7">
          บันทึกประวัติการเข้าเรียนและสรุปผลการข้อสอบ
        </span>
      </div>
      <div class="d-flex align-items-center gap-4">
        <!-- <button
      class="btn btn-sm btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800"
    >
      ยกเลิก
    </button> -->
      </div>
    </div>
    <div class="separator my-4 mb-3"></div>

    <!-- `align-items-start`: the child selector sits in this same flex row for
         a parent, and without it the tabs stretched to the selector's height.
         The active underline is positioned at `top-100` of its link, so it
         detached and floated ~45px below the label it belongs to. -->
    <ul class="nav nav-stretch nav-pills nav-pills-custom d-flex align-items-start" role="tablist">
      <!-- Courses first, then time, then results, then skills: what they are
           taking, how much they have put in, how it went, what it means. The
           2021 build's parent area opened on the same question. -->
      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800"
          routerLink="/profile/monitor/progress" [queryParams]="isStudent() ? {} : { student_id: selectedStudentId() }"
          routerLinkActive="active" aria-selected="true" role="tab" data-testid="tab-progress">
          <span class="nav-text fw-semibold fs-6">{{ "MONITOR.PROGRESS" | translate }}</span>
          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"></span>
        </a>
      </li>
      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800" data-bs-toggle="tab"
          routerLink="/profile/monitor/study-record"
          [queryParams]="isStudent() ? {} : { student_id: selectedStudentId() }" routerLinkActive="active"
          aria-selected="true" role="tab">
          <span class="nav-text fw-semibold fs-6"> เวลาเรียน </span>
          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"></span>
        </a>
      </li>
      <!-- Carries the same child as the skills tab beside it. Without the query
           param the parent landed on their OWN history, which is empty, while
           the tab next door reported the child had finished eleven sets. -->
      <!-- //TODO wait for v2.1 feature -->
      <!-- <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800"
          routerLink="/profile/monitor/quiz-record"
          [queryParams]="isStudent() ? {} : { student_id: selectedStudentId() }" routerLinkActive="active"
          aria-selected="true" role="tab" data-testid="tab-quiz-record">
          <span class="nav-text fw-semibold fs-6">{{ "QUIZ.HISTORY" | translate }}</span>

          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"></span>
        </a>
      </li>
      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800"
          routerLink="/profile/monitor/skills" [queryParams]="isStudent() ? {} : { student_id: selectedStudentId() }"
          routerLinkActive="active" aria-selected="true" role="tab" data-testid="tab-skills">

          <span class="nav-text fw-semibold fs-6">{{
            (isStudent() ? "QUIZ.MY_SKILLS" : "QUIZ.CHILD_SKILLS") | translate
            }}</span>

          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"></span>
        </a>
      </li> -->
      <!-- Only when there is a choice to make. A parent who looks after one
           child does not need a picker, and a parent who looks after none needs
           the panel below, not an empty dropdown. -->
      @if(!isStudent() && underParenting().length > 1){
      <div class="d-flex flex-end flex-fill" [formGroup]="form">
        <div class="col-12 col-sm-10 col-lg-8 col-xl-6 mb-sm-4 mt-6 mt-sm-4 mb-sm-0">
          <app-select name="student_id" formControlName="student_id" placeholder="APP.STUDENT" label="นักเรียนที่ดูแล"
            bindLabel="student.full_name" bindValue="student_id" [labelMode]="LabelMode.INLINE"
            [options]="underParenting()" [clearable]="false"></app-select>
        </div>
      </div>

      }
    </ul>

    <!-- A parent with nobody in their care lands on four tabs of nothing.
         The 2021 build said so and linked to where you add a student; the tabs
         are pointless until that is done. -->
    @if(!isStudent() && !isLoading() && !underParenting().length){
    <div class="empty-state" data-testid="no-children">
      <span class="empty-state__mark">
        <app-keenicon name="people" class="fs-2tx"></app-keenicon>
      </span>
      <p class="empty-state__title">{{ "APP.NO_CHILDREN" | translate }}</p>
      <p class="empty-state__body">{{ "APP.NO_CHILDREN_HINT" | translate }}</p>
      <a class="btn btn-primary" routerLink="/profile/student">
        {{ "APP.ADD_STUDENT" | translate }}
      </a>
    </div>
    } @else {
    <div class="tab-content mb-2">
      <div class="tab-pane fade active show" role="tabpanel">
        @if(!isLoading()){
        <router-outlet></router-outlet>
        }@else{ @if (tabIndex === 1) {
        <!-- <ng-container *ngTemplateOutlet="skeletonType1"></ng-container> -->

        }@else {
        <!-- <ng-container *ngTemplateOutlet="skeletonType2"></ng-container> -->

        } }
      </div>
    </div>
    }
  </div>
</div>

<ng-template #skeletonType1>
  <div class="col-12 mt-6 mb-3">
    <div class="min-h-35px col-3 skeleton"></div>
  </div>
  <div class="d-flex flex-row justify-content-between col-12 mb-4">
    <div class="min-h-45px col-4 skeleton"></div>
    <div class="d-flex flex-row al justify-content-end gap-4 col-8 mt-2">
      <div class="mh-35px w-50px skeleton"></div>
      <div class="mh-35px w-50px skeleton"></div>
      <div class="mh-35px w-50px skeleton"></div>
    </div>
  </div>
  <div class="min-h-325px w-100 skeleton"></div>
  <div class="separator my-4"></div>
  <div class="page-title d-flex flex-column justify-content-center flex-wrap mt-8">
    <div class="col-12">
      <div class="min-h-35px col-3 skeleton"></div>
    </div>
  </div>

  <div class="min-h-250px w-100 mt-6 skeleton"></div>
</ng-template>
<ng-template #skeletonType2>
  <!-- <div class="col-12 m-4">
    <div class="min-h-35px col-3 skeleton"></div>
  </div> -->
  <div class="d-flex flex-row justify-content-between col-12 mt-6 mb-4 py-1">
    <div class="min-h-45px col-4 skeleton"></div>
    <div class="d-flex flex-row al justify-content-end gap-4 col-8 mt-2">
      <div class="mh-35px w-50px skeleton"></div>
      <div class="mh-35px w-50px skeleton"></div>
      <div class="mh-35px w-50px skeleton"></div>
    </div>
  </div>
  <div class="min-h-125px py-1 w-100 skeleton"></div>
  <div class="d-flex justify-content-center align-items-center py-8 mt-4">
    <div class="skeleton col-12 h-250px w-250px rounded-circle"></div>
  </div>
  <div class="separator my-4"></div>
  <div class="page-title d-flex flex-column justify-content-center flex-wrap mt-8">
    <div class="col-12">
      <div class="min-h-35px col-3 skeleton"></div>
    </div>
  </div>

  <div class="min-h-250px w-100 mt-6 skeleton"></div>
</ng-template>